import {
  reactive, ref, watch, toRef, computed,
} from '@vue/composition-api'
import formatDate from '@/utils/date-format'
import { tripStatusFormatter } from './tripStatusUtils'
import { errorNotification } from '@/utils/toast-notifications'
import reFetchAPI from '@/utils/refetch-api'
// import axiosIns from '@/libs/axios'
// import axios from 'axios'

export default function useTripsList(ctx) {
  const userData = JSON.parse(localStorage.getItem('userData'))
  const userCountry = userData?.country

  const disableDateAt = () => {
    const now = new Date()
    now.setMonth(now.getMonth() - 1)
    now.setHours(0, 0, 0, 0)
    return now
  }
  const tableColumns = [
    {
      label: 'Trip Number',
      key: 'number',
    },
    {
      label: 'created at',
      key: 'createdAt',
      formatter: val => formatDate(val),
    },
    {
      label: 'Rider',
      key: 'userDetails',
      formatter: val => `${val?.first_name} ${val?.last_name}`,
    },
    {
      label: 'Driver',
      key: 'driver',
      formatter: val => val && `${val?.first_name} ${val?.last_name}`,
    },
    {
      label: 'Driver ID',
      key: 'driverId',
    },
    {
      label: 'Zone',
      key: 'zone',
      formatter: val => val?.split('::')[1],
    },
    {
      label: 'Type',
      key: 'className',
    },
    {
      label: 'status',
      key: 'state',
      formatter: val => tripStatusFormatter(val),
    },
  ]

  const stateOptions = [
    {
      label: 'All',
      key: 'ALL',
    },
    {
      label: 'Created',
      key: 'CREATED',
    },
    {
      label: 'Canceled',
      key: 'CANCELED',
    },
    {
      label: 'Accepted',
      key: 'ACCEPTED',
    },
    {
      label: 'Arrived',
      key: 'ARRIVED',
    },
    {
      label: 'In progress',
      key: 'IN_PROGRESS',
    },
    {
      label: 'Looking for driver',
      key: 'LOOKING_FOR_DRIVER',
    },
    {
      label: 'No driver found',
      key: 'NO_DRIVER_FOUND',
    },
  ]

  if (userCountry === 'LY') {
    stateOptions.splice(1, 0, {
      label: 'Completed',
      key: 'COMPLETED',
    })
  }
  const loading = ref(false)
  const tripsList = ref([])
  const totalTrips = ref(0)
  const currState = ref('ALL')
  const tripId = ref()
  const queryParams = reactive({
    size: 10,
    page: 1,
    state: 'ALL',
    user_phone: undefined,
    driver_phone: undefined,
    trip_id: undefined,
  })
  const tempTime = new Date()
  const dateTimeFilter = reactive({
    fromDate: `${tempTime.getFullYear()}-${tempTime.getMonth() + 1}-${tempTime.getDate()}`,
    fromTime: undefined,
    toDate: `${tempTime.getFullYear()}-${tempTime.getMonth() + 1}-${tempTime.getDate()}`,
    toTime: undefined,
  })
  const setFilterDateFormat = () => {
    if (dateTimeFilter.fromDate) {
      if (!dateTimeFilter.fromTime) {
        queryParams.from = new Date(`${dateTimeFilter.fromDate} 00:00:00`)
      } else {
        queryParams.from = new Date(`${dateTimeFilter.fromDate} ${dateTimeFilter.fromTime}`)
      }
    }
    if (dateTimeFilter.toDate) {
      if (dateTimeFilter.fromDate) {
        if (!dateTimeFilter.toTime) {
          const now = new Date()
          queryParams.to = new Date(`${dateTimeFilter.toDate} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`)
        } else {
          queryParams.to = new Date(`${dateTimeFilter.toDate} ${dateTimeFilter.toTime}`)
        }
        return true
      }
      errorNotification('You should fill the from date and time first')
      return false
    }
    return true
  }

  const fetchTripsList = async () => {
    if (loading.value) return
    try {
      const val = setFilterDateFormat()
      if (!val) return
      loading.value = true
      if (currState.value === 'ALL') {
        queryParams.state = undefined
      } else {
        queryParams.state = currState.value
      }
      if (tripId.value) {
        queryParams.trip_id = tripId.value
      } else {
        queryParams.trip_id = undefined
      }
      const res = await ctx.root.$store.dispatch('trips/fetchTripsList', queryParams)
      const { trips, total } = res.data.data
      tripsList.value = trips.map(trip => ({
        ...trip,
        driverId: trip.driver ? trip.driver.driver_id : undefined,
      }))
      totalTrips.value = total
    } catch (error) {
      if (error.message.includes('timeout')) {
        fetchTripsList()
      } else {
        reFetchAPI(fetchTripsList)
        errorNotification('Something went wrong!!, retrying..')
      }
    } finally {
      loading.value = false
    }
  }
  const applySearch = () => {
    queryParams.page = 1
    fetchTripsList()
  }
  const clearFilter = () => {
    currState.value = 'ALL'
    queryParams.state = undefined
    dateTimeFilter.fromDate = undefined
    dateTimeFilter.toDate = undefined
    dateTimeFilter.fromTime = undefined
    dateTimeFilter.toTime = undefined
    queryParams.from = undefined
    queryParams.to = undefined
    queryParams.driver_phone = undefined
    queryParams.user_phone = undefined
    queryParams.trip_id = undefined
    tripId.value = undefined
    if (userCountry === 'LY') {
      fetchTripsList()
    }
  }
  if (userCountry === 'LY') {
    fetchTripsList()
  }
  watch([toRef(queryParams, 'size')], () => {
    fetchTripsList()
  })

  const navigateToTripDetails = id => window.open(`${window.location.origin}/trips/${id}`)
  const canSearch = computed(() => {
    if (userCountry === 'LY') return true
    return queryParams.driver_phone || queryParams.user_phone || tripId.value
  })
  return {
    disableDateAt,
    tableColumns,
    loading,
    canSearch,
    tripsList,
    fetchTripsList,
    totalTrips,
    queryParams,
    dateTimeFilter,
    stateOptions,
    clearFilter,
    currState,
    tripId,
    applySearch,
    navigateToTripDetails,
  }
}
